import React, { Component } from 'react'

class IconWrong extends Component {
  render() {
    return (
      <div>
        <div className="rounded-icons rounded" />
        <svg className="icon-spark icon-right" width="51" height="57">
          <g fill="none" opacity=".536">
            <path
              fill="#B13640"
              d="M8.695 29.501c-.94 2.585-2.172 4.51-2.75 4.3l-4.97-1.81c-.579-.21-.285-2.476.656-5.06L9.721 4.7c.941-2.584 2.172-4.509 2.75-4.298l4.971 1.81c.578.21.284 2.475-.657 5.06l-8.09 22.229zM35.891 45.826l-6.04-2.199c-.04.41-.124.821-.272 1.226l-2.98 8.19c-.941 2.584-3.812 3.912-6.413 2.965l-1.202-15.011c.147-.405-9.407-7.122-8.466-9.706l8.09-22.23c.94-2.583 3.812-3.912 6.413-2.965l22.368 8.141c2.6.947 3.946 3.81 3.006 6.394L42.304 42.86c-.94 2.584-3.812 3.912-6.413 2.966z"
            />
          </g>
        </svg>
        <svg className="icon-spark icon-top" width="41" height="43">
          <g fill="none">
            <path
              fill="#B13640"
              d="M10.523 28.17c.404 2.291.317 4.223-.196 4.313l-4.407.777c-.513.09-1.256-1.694-1.66-3.986L.785 9.564C.381 7.275.47 5.343.981 5.253l4.408-.777c.512-.09 1.255 1.694 1.66 3.986l3.475 19.709zM37.356 28.626l-5.357.944c.145.317.257.655.32 1.013l1.28 7.262c.405 2.291-1.137 4.479-3.443 4.885l-7.231-10.49c-.063-.36-9.905-1.239-10.31-3.53L9.142 9c-.404-2.29 1.137-4.479 3.443-4.885L32.417.618C34.723.21 36.92 1.74 37.324 4.03L40.8 23.74c.404 2.29-1.137 4.478-3.443 4.885z"
            />
          </g>
        </svg>
        <svg className="icon-spark icon-bottom" width="30" height="34">
          <g fill="none">
            <path
              fill="url(#paint0_linear)"
              d="M4.436 16.9c0 1.623-.294 2.939-.657 2.939H.657c-.363 0-.657-1.316-.657-2.94V2.94C0 1.316.294 0 .657 0H3.78c.363 0 .657 1.316.657 2.939V16.9z"
              transform="rotate(20 3.163 18.156)"
            />
            <path
              fill="url(#paint1_linear)"
              d="M17.005 19.839h-3.793c.06.235.097.48.097.734v5.143a2.948 2.948 0 0 1-2.958 2.94l-3.697-8.083C6.654 20.32 0 18.523 0 16.9V2.94A2.948 2.948 0 0 1 2.957 0h14.049a2.948 2.948 0 0 1 2.957 2.939V16.9a2.948 2.948 0 0 1-2.958 2.94z"
              transform="rotate(20 -1.51 34.314)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear"
              x2="1"
              gradientTransform="matrix(-5.84797 57.9061 -12.9489 -26.1514 8.066 -38.068)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CA5E6B" />
              <stop offset="1" stopColor="#9A3039" />
            </linearGradient>
            <linearGradient
              id="paint1_linear"
              x2="1"
              gradientTransform="matrix(-26.3153 83.6418 -58.2689 -37.7742 36.297 -54.986)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CA5E6B" />
              <stop offset="1" stopColor="#9A3039" />
            </linearGradient>
          </defs>
        </svg>
        <div className="icon-centered-holder ">
          <div className="icon-centered rounded failed">
            <svg width="39" height="39">
              <path
                fill="#fff"
                d="M23.447 19.75L38.234 4.963a2.614 2.614 0 0 0-3.697-3.697L19.75 16.053 4.963 1.266a2.614 2.614 0 0 0-3.697 3.697L16.053 19.75 1.266 34.538a2.614 2.614 0 0 0 3.697 3.696L19.75 23.447l14.788 14.787a2.614 2.614 0 0 0 3.696-3.697L23.447 19.75z"
              />
            </svg>
          </div>
        </div>
      </div>
    )
  }
}

export default IconWrong



// WEBPACK FOOTER //
// ./src/svg/icon-wrong.js